import { useCallback, useMemo } from 'react';
import { useQuery } from 'react-query';
import * as Icons from '@ant-design/icons';
import { CustomsService } from '../../services';

export const useCustomsStatus = () => {
  // Ping is sent only on demand (click) — never on mount, focus or reconnect
  const { data, isFetching, refetch } = useQuery(
    ['customs', 'status'],
    async () => {
      const result = await CustomsService.getStatus();
      return result.data;
    },
    { enabled: false },
  );

  const handleClick = useCallback(() => {
    if (isFetching) return;
    refetch();
  }, [isFetching, refetch]);

  const status = useMemo(() => (isFetching ? 'processing' : data?.status ? data.status : 'default'), [data?.status, isFetching]);

  const icon = useMemo(() => {
    switch (status) {
      case 'success':
        return <Icons.CheckCircleOutlined />;
      case 'error':
        return <Icons.CloseCircleOutlined />;
      case 'warning':
        return <Icons.ExclamationCircleOutlined />;
      case 'processing':
        return <Icons.SyncOutlined spin={true} />;
      default:
        return <Icons.QuestionCircleOutlined />;
    }
  }, [status]);

  const title = useMemo(() => {
    const hint = 'Statusu yoxlamaq üçün klikləyin';
    switch (status) {
      case 'success':
        return `İşləkdir. ${hint}`;
      case 'error':
        return `İşlək deyil. ${hint}`;
      case 'warning':
        return `Təyin olunmayıb. ${hint}`;
      case 'processing':
        return 'Yoxlanılır...';
      default:
        return hint;
    }
  }, [status]);

  return { title, status, icon, handleClick };
};
